import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseEntity } from '../../shared/base-entity-model';
import { Account } from './account-model';
import { FullMarketplace, MarketplaceDto } from './marketplace-model';
import { StoreGroup } from './store-group-model';
import { PublicationRuleStore } from '@models/configuration/rules/publication-rule/publication-rule-store-model';

@JsonObject('StoreWithoutMarketplace')
class StoreWithoutMarketplace extends BaseEntity {
  @JsonProperty('id', Number, true) id: number = undefined;

  @JsonProperty('name', String, true) name: string = undefined;
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('country', String, true) country: string = undefined;
  @JsonProperty('currency', String, true) currency: string = undefined;
  @JsonProperty('channelStoreName', String, true) channelStoreName: string = undefined;

  @JsonProperty('account', Account, true) account: Account = undefined;
  @JsonProperty('storeGroup', StoreGroup, true) storeGroup: StoreGroup = undefined;
}

@JsonObject('Store')
export class Store extends StoreWithoutMarketplace {
  @JsonProperty('marketplace', MarketplaceDto, true) marketplace: MarketplaceDto = undefined;
}

@JsonObject('FullStore')
export class FullStore extends StoreWithoutMarketplace {
  @JsonProperty('marketplace', FullMarketplace, true) marketplace: FullMarketplace = undefined;
}

export const publicationRuleStoreFromFullStore = (s: FullStore): PublicationRuleStore => {
  const newStore = new PublicationRuleStore();
  newStore.storeId = s.id;
  newStore.name = s.name;
  newStore.code = s.code;
  newStore.marketplaceName = s.marketplace.name;
  newStore.currency = s.currency;
  newStore.country = s.country;
  newStore.networkType = s.account?.connection?.marketplaceConnectionType
    ? s.account?.connection?.marketplaceConnectionType
    : s.marketplace.network;
  newStore.accountConnectionName = s.account.connection.name;
  newStore.channelStoreName = s.channelStoreName;
  newStore.sellingPlatform = s.marketplace.sellingPlatform.name;
  return newStore;
};
